module.exports = __webpack_public_path__ + "static/disability-access-6f99ddd5958cf384e4385eeda6a4658a.png";